<template class="test">
	<main-parent>
		<div class="page-container">
			<md-dialog :md-active.sync="showDialogForMDLP" class="mdlp-qa-dialog">
				<iframe class="mdlp-info" v-bind:src="'/mdlp.html?' + cacheBreaker"></iframe>
				<md-dialog-actions>
					<md-button class="md-primary" @click="showDialogForMDLP = false">Закрыть</md-button>
				</md-dialog-actions>
			</md-dialog>
			<md-app md-mode="fixed">
				<md-app-toolbar id="application-toolbar" class="md-primary md-dense" style="display: block;" md-elevation="0">
					<span class="app-header">
						<div class="header-left">
							<div class="refresh-block">
								<div>Обновлено</div>
								<div style="width: 60px;">
									<transition name="fadedate">
										<span style="margin-left: 5px" v-show="showDate">
											{{(new Date(timeOfLastCheck)).toLocaleTimeString('ru')}}
										</span>
									</transition>
								</div>
							</div>
							<md-button class="md-icon-button md-dense md-accent" id="time-update-button" @click="manualAutoUpdate" :disabled="loading">
								<md-icon style="color: white;">refresh</md-icon>
								<md-tooltip md-direction="top" md-delay="500">Обновить данные</md-tooltip>
							</md-button>
							<md-button @click="updateCacheBreaker(); showDialogForMDLP = true;"
									   class="md-accent md-raised mdlp-title-button">
								Общие вопросы и ответы по МДЛП
							</md-button>
						</div>
						<div class="news-text" v-if="newsMessages.length > 0">
							<span>{{newsText(newsIdx)}}</span>
							<md-tooltip style="height: auto" md-delay="500">
								<div style="white-space:normal">{{newsText(newsIdx)}}</div>
							</md-tooltip>
							<div style="text-align: center;" v-if="newsMessages.length > 1">
								<md-radio class="news-radio md-primary" md-theme="green" v-for="(message, index) in newsMessages" v-model="newsIdx" v-bind:value="index" @change="newsSwitched"/>
							</div>
						</div>
						<div v-else class="news-text"></div>
						<div class="header-right">
							<div v-if="ISAUTHENTICATED">
								<p class="ellipsis-text">{{ CURRENTAPTEKA.name }} ({{ CURRENTAPTEKA.idapt }})</p>
								<p class="ellipsis-text" v-if="CURRENTUSER.fullName">{{ CURRENTUSER.fullName }}</p>
								<md-tooltip style="height: auto">
									<p>{{ CURRENTAPTEKA.name }} ({{ CURRENTAPTEKA.idapt }}</p>
									<p v-if="CURRENTUSER.fullName">{{ CURRENTUSER.fullName }}</p>
								</md-tooltip>
							</div>
							<md-button class="md-icon-button" @click="goToUserPage" v-if="ISRUNINFZ === 'false'">
								<md-icon>account_box</md-icon>
								<md-tooltip md-direction="top" md-delay="500" v-if="CURRENTUSER.userId">
									Страница
									пользователя
								</md-tooltip>
								<md-tooltip md-direction="top" md-delay="500" v-else>Регистрация пользователя</md-tooltip>
							</md-button>
							<md-button class="md-icon-button" @click="logout()" style="margin-left:0"
									   v-if="ISRUNINFZ === 'false'">
								<md-icon>exit_to_app</md-icon>
								<md-tooltip md-direction="top" md-delay="500">Выход</md-tooltip>
							</md-button>
						</div>
					</span>
				</md-app-toolbar>
				<md-app-content id="app-content" class="app-content-cl">
					<div class="content app-container">
						<div>
						<slot v-if='page.status !== "loading"'></slot>
						</div>
						<div class="app-footer">
							<div class="footer-left"></div>
							<div class="footer-center">
								<span class="version-block">&copy; «ООО КВЕРТИ+», {{new Date().getFullYear()}} (версия сайта {{APPBUILDVERSION.version}} от {{APPBUILDVERSION.date}})</span>
							</div>
							<div class="footer-right">
								<span v-if="DATABASEVERSION === 'test'" class="testdb-block">тестовая база</span>
							</div>
						</div>
					</div>
				</md-app-content>
			</md-app>
		</div>
	</main-parent>
</template>

<script>
import MainParent from '../MainParent'
import DrawerProgressBar from "./DrawerProgressBar";
import { mapGetters } from 'vuex'

export default {
	components: {
		DrawerProgressBar,
		MainParent,
	},
	name: 'Drawer',
	data: () => ({
		menuVisible: false,
		search: '',
		timeOfLastCheck: new Date(),
		newsMessages: [],
		showDialogForMDLP: false,
		cacheBreaker: '',
		loading: false,
		showDate: true,
		newsIdx: 0,
		newsTimer: null
	}),
	methods: {
		setTheme(theme) {
			this.$material.theming.theme = theme
		},
		toggleMenu() {
			this.menuVisible = !this.menuVisible
		},
		logout() {
			//очистка state (возвращение перевоначального состояния) происходит в router/index.js action CLEAR_STATE
			this.$store.dispatch('SET_ISAUTHENTICATED', false);
			this.$router.push({ path: "/login" });
		},
		simpleClick() {
			this.menuVisible = false
		},
		goToUserPage() {
			this.$router.push({ path: "/userPage" });
		},
		getNews() {
                this.$http
					.post('data/GetNews', {
                        idApt: this.CURRENTAPTEKA.idapt
                    })
                    .then(
						response => {
							if (response.data.error) {
                                this.$store.dispatch("showSnackBar", {
                                    snackText: "Ошибка получения новостей"
								});
								return;
							}
							clearInterval(this.newsTimer);
							this.newsMessages = response.data;
							if (this.newsIdx >= this.newsMessages.length) {
								this.newsIdx = 0;
							}
							if (this.newsMessages.length > 0) {
								this.initNewsTimer();
                            }
                        },
						() => {
							this.newsMessages = [];
                            this.$store.dispatch("showSnackBar", {
                                snackText: "Ошибка получения новостей"
                            });
                        }
                    )
                    .finally(() => {
                    });
            },
			updateCacheBreaker() {
                this.cacheBreaker = String(+new Date())
            },
			manualAutoUpdate() {
				this.$root.$emit('refresh-from-root');
			},
			onUpdateTimeChanged(dt) {
				this.timeOfLastCheck = dt;
				this.getNews();
			},
			newsText(idx) {
				if (idx < 0 || this.newsMessages.length <= idx) {
					return null;
				}
				return this.newsMessages[idx].body;
			},
			newsSwitched() {
				clearInterval(this.newsTimer);
				this.initNewsTimer();
			},
			initNewsTimer() {
                this.newsTimer = setInterval(() => {
                    this.newsIdx++;
                    if (this.newsIdx >= this.newsMessages.length) {
                        this.newsIdx = 0;
                    }
                }, 15000)
			}
	},
	computed: {
		...mapGetters([
			'SUPPORTCURRENTTABROUTE',
			'CURRENTAPTEKA',
			'ISAUTHENTICATED',
			'CURRENTUSER',
			'ISRUNINFZ',
			'DATABASEVERSION',
			'APPBUILDVERSION'
		]),
		phonesTab() {
			return this.PHONESCURRENTTABROUTE;
		},
		supportTab() {
			return this.SUPPORTCURRENTTABROUTE;
		},
		page() {
			return this.$store.state.page
		},
		userInfo() {
			return this.$store.state.user
		},
		menu() {
			return this.$store.state.menu
		}
	},
	mounted() {
		this.$root.$on("last-check-time-updated", this.onUpdateTimeChanged);
		var elem = document.getElementById("application-toolbar");
		this.$store.dispatch('setApp', { 'toolbarHeight': elem.clientHeight });
		if (document.documentElement.clientHeight > 900) {
			this.$store.dispatch('setApp', { 'tableHeight': document.documentElement.clientHeight - 216 - 50 - 5 }); //216
		} else {
			this.$store.dispatch('setApp', { 'tableHeight': document.documentElement.clientHeight - 192 - 50 - 5 }); //192
		}
		this.getNews();
	}
}
</script>

<style lang="scss" scoped>
@media (max-width: 1900px) {
	.md-drawer {
		width: 200px;
		max-width: calc(100vw - 125px);
	}

	.md-app {
		margin: 0;
		height: 100vh;
	}

	.md-app-content {
		/*background: aqua;*/
		padding: 5px;
	}
}

@media (max-width: 700px) {
	#application-toolbar {
		font-size: 0.7rem;
	}
}

.page-container {
	min-width: 600px;
}

.pharm-info {
	display: flex;
	flex-direction: column;
}

.app-footer {
	margin-top: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
}


.app-container {
	display: flex;
	flex-direction: column;
	height: 100%;
	max-height: 100%;
}
.app-content-cl {
	height: 100%;
}
.version-block {
	font-size: 0.9rem;
	opacity: 0.7;
}
.testdb-block {
	opacity: 0.5;
	font-size: 1rem;
	font-weight: bold;
	margin-left: auto;
}
.footer-left{
	display: flex;
	width: 33%
}
.footer-center{
	display: flex;
	width: 33%
}
.footer-right{
	display: flex;
	width: 33%
}
.ellipsis-text {
	margin-top: 0;
	margin-bottom: 0;
	white-space: nowrap;
	overflow: hidden;
	max-width: 200px;
	text-overflow: ellipsis;
}
.mdlp-qa-dialog {
	width: 80%;
	height: 80%;
	max-width: 768px;
	margin: auto;
}
.refresh-block {
	align-items: center;
	font-size: 0.8rem;
	color: white;
}
.app-header{
	display: flex;
	flex-direction: row;
	align-items: center;
	max-width: 100%;
}
.header-left {
	display: flex;
	flex-direction: row;
	align-items: center;
}
.header-right {
	display: flex;
	flex-direction: row;
	align-items: center;
}
.mdlp-title-button {
    white-space: normal;
	width: 195px;
}

.news-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
	margin-left: auto;
	margin-right: auto;
	min-width: 100px;
	padding-left: 5px;
	padding-right: 5px;
}
.news-text span {
    animation: blink 5s linear infinite;
}
.news-radio {
	margin-top: 0;
	margin-bottom: 0;
	margin-left: 0;
	margin-right: 5px;
	transform: scale(0.7)
}

@keyframes blink {
    0%, 90%, 100% {
        opacity: 1;
    }

    95% {
        opacity: 0;
    }
}
</style>


// WEBPACK FOOTER //
// Components/common/Drawer.vue